export default "__VITE_ASSET__135f17e4__"